import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { action, computed, observable } from 'mobx';
import { EnumAPI } from '../../apis';
import { BasesController } from '../bases';

@BindAll()
export class RapidQuotationAddressController<
  T = any,
> extends BasesController<T> {
  constructor() {
    super();
    this.reset({
      dataKey: 'id',
      infinite: false,
      pagination: EnumAPI.rapidQuotation_addressList,
      details: EnumAPI.rapidQuotation_addressDetails,
      insert: EnumAPI.rapidQuotation_addOrUpdateAddress,
      update: EnumAPI.rapidQuotation_addOrUpdateAddress,
      delete: EnumAPI.rapidQuotation_removeAddress,
      paginationParams: {
        response: {
          valueGetter: this.valueGetter,
        },
      },
    });
  }
  private valueGetter(response) {
    const addressList = lodash.get(response, 'addressList');
    const dataSource = lodash.map(addressList, (item, index: any) => {
      let isDefault;
      if (this.selectAddress && this.selectAddress[this.distributorCode]) {
        isDefault = lodash.eq(
          item.id,
          this.selectAddress[this.distributorCode].id,
        );
      } else {
        isDefault = index == 0;
      }
      return lodash.merge(item, {
        isDefault: isDefault,
        name: item.consignee,
        tel: item.mobile,
        address: lodash
          .compact([
            lodash.get(item, 'provinceName'),
            lodash.get(item, 'cityName'),
            lodash.get(item, 'countyName'),
            lodash.get(item, 'details'),
          ])
          .join(' / '),
      });
    });
    return {
      isIncludeSign: lodash.get(response, 'isIncludeSign'),
      dataSource,
    };
  }
  @observable
  distributorCode = '';

  @action.bound
  setDistributorCode(val) {
    this.distributorCode = val;
  }
  /**
   * @desc BPP 收货地址
   */
  @computed
  get BppDataSource() {
    return lodash.filter(this.dataSource, ['source', 'BPP-SMB']);
  }
  /**
   * @desc Sec 收货地址
   */
  @computed
  get SecDataSource() {
    return lodash.filter(this.dataSource, ['source', 'SEC']);
  }
  @computed
  get isIncludeSign(): boolean {
    return this.Pagination.Model.getStorage('response.isIncludeSign', false);
  }
  @computed
  public get selectAddress() {
    return this.Details.Model.getStorage('selectAddress') || {};
  }

  onSelectAddress(address) {
    lodash.each(this.dataSource, (item: any) => {
      item.isDefault = lodash.eq(item.id, address.id);
    });

    this.Details.Model.setStorage('selectAddress', address);
  }
}
